import React from 'react';
import { useInit } from '../../hooks/usefetch';
import './index.css'
import { Typography } from '@mui/material';

export const Disclaimer: React.FC = () => {
  const { data } = useInit();

  const policyText = data?.policyText?.replace('{{policy}}', `<a href="${data.policyUrl}" target="_blank" rel="noopener noreferrer">Privacy Policy</a>`);

  return (
      <Typography 
      style={{
        fontFamily: 'NHaasGroteskTXPro-55Rg',
        fontSize: '17px',
      }} 
      dangerouslySetInnerHTML={{ __html: policyText }}></Typography>
  );
};